import React, { useState } from 'react';
import { Box } from '@material-ui/core';
import { registerEmploymentDetailsStep as registerLocales } from 'globals/locales/registration';
import FsRegisterEmploymentDetailsForm from 'ui-elements/forms/FsRegisterEmploymentDetailsForm';
import { FsRegisterEmploymentDetailsFormDataProps } from 'ui-elements/forms/FsRegisterEmploymentDetailsForm/FsRegisterEmploymentDetailsForm';
import {
  FsCounterBox,
  FsHello,
  FsHelloWrapperBox,
  FsCenterBoxLine,
  FsCenterBoxSubTitle,
  FsCenterBoxTitle,
} from 'ui-elements/center-box-elements/FsCenterBoxElements.style-elements';
import { WrapperBox } from './RegisterEmploymentDetailsStep.style-elements';
import { RegisterStepProps } from '../Steps.types';

interface RegisterEmploymentBasicsStepProps extends RegisterStepProps {
  onGoNext?: (props?: FsRegisterEmploymentDetailsFormDataProps) => void;
}

const RegisterEmploymentDetailsStep: React.FC<RegisterEmploymentBasicsStepProps> = ({
  stepIndex,
  stepsLength,
  onGoNext,
}) => {
  const [formDefaults] = useState<FsRegisterEmploymentDetailsFormDataProps>({
    department: '',
    industry: '',
    numberOfEmployees: '',
    numberOfCustomers: '',
  });

  return (
    <WrapperBox>
      <FsHelloWrapperBox>
        <FsHello>{registerLocales.hello}</FsHello>
        <FsCounterBox>
          <i>{stepIndex}</i>/{stepsLength}
        </FsCounterBox>
      </FsHelloWrapperBox>
      <Box maxWidth={400}>
        <FsCenterBoxTitle>{registerLocales.title}</FsCenterBoxTitle>
        <FsCenterBoxSubTitle>{registerLocales.subTitle}</FsCenterBoxSubTitle>
        <FsCenterBoxLine />
      </Box>
      <Box marginTop={3}>
        <FsRegisterEmploymentDetailsForm
          {...formDefaults}
          onGoNext={onGoNext}
        />
      </Box>
    </WrapperBox>
  );
};

export default RegisterEmploymentDetailsStep;
